$(document).ready(function () {
  const $modal = $('#create-header-link');

  const headerLinkForm = function () {
    return $modal.find('form');
  };

  const setFormForCreate = function () {
    const createAction = $modal.data('create-action') || $modal.attr('data-create-action');
    resetCreateModal();
    headerLinkForm().attr('action', createAction);
    headerLinkForm().attr('method', 'post');
    $modal.find('.modal-title').text('新規作成');
  };

  const setFormForEdit = function (updateAction) {
    const $form = headerLinkForm();
    $form.attr('action', updateAction);
    $form.attr('method', 'post');
    $form.find('input[name="_method"]').remove();
    $form.prepend('<input type="hidden" name="_method" value="patch">');
    $modal.find('.modal-title').text('編集');
  };

  $('.js-cancel-create-header-link').on('click', function () {
    $modal.modal('hide');
    setFormForCreate();
  });

  $(document).on('click', '.js-create-header-link', function () {
    setFormForCreate();
    $modal.modal('show');
  });

  $(document).on('click', '.js-edit-header-link', function () {
    const $icon = $(this).closest('.header-link-icon');
    const headerLinkId = $icon.attr('data-header-link-id') || $icon.data('headerLinkId');
    const updateAction = $icon.attr('data-update-action') || ('/header_links/' + headerLinkId);

    resetCreateModal();
    $modal.find('.modal-title').text('編集');

    $.ajax({
      url: '/header_links/' + headerLinkId + '/info',
      method: 'GET',
      dataType: 'json',
      success: function (res) {
        const headerLink = res.header_link;
        setFormForEdit(updateAction);
        $('#title_header_link').val(headerLink.title);
        $('#url_header_link').val(headerLink.url);
        $('#position_header').val(headerLink.position);
        $modal.modal('show');
      },
    });
  });

  function resetCreateModal() {
    $('.help-block').remove();
    $('.has-error').removeClass('has-error');
    $('#title_header_link').val('');
    $('#url_header_link').val('');
    headerLinkForm().find('input[name="_method"]').remove();
    $('#position_header').val('');
  }

  const element = document.querySelector('.header-link');
  if (element) {
    element.addEventListener('wheel', (event) => {
      event.preventDefault();

      element.scrollBy({
        left: event.deltaY < 0 ? -30 : 30,
      });
    });
  }
});
